import React, { useMemo } from 'react';
import { useSelector } from "react-redux";
import { RecentDayNotes } from '@features/whereabouts/services/WhereaboutOptions';
import { selectRecentDayNotes } from '@features/whereabouts/store/dayNotes.duck';
import { BodySmall } from "../../../atoms/fonts/Body";
import { DayNotePill, RecentNotesContainer } from "./DayNotesActivityItem";

export function RecentNotes(props: Props) {
  const {whereaboutsOptionId, onNoteSelected} = props;
  const recentDayNotes = useSelector(selectRecentDayNotes);

  const limitedRecentDayNotes = useMemo(() => {
    const filtered = recentDayNotes.filter((rdn: RecentDayNotes) => rdn.whereaboutsOptionId === whereaboutsOptionId);
    if (filtered.length > 3) {
      return filtered.slice(0, 3);
    }
    return filtered;
  }, [whereaboutsOptionId, recentDayNotes]);

  if (limitedRecentDayNotes.length === 0) {
    return null;
  }

  const onDayNotePillClicked = (e: any, dayNote: RecentDayNotes) => {
    e.stopPropagation();
    onNoteSelected(e, dayNote.note);
  }

  return (
    <RecentNotesContainer>
      {limitedRecentDayNotes.map((dayNote: RecentDayNotes, key: number) => (
        <React.Fragment key={key}>
          <DayNotePill onClick={(e: Event) => onDayNotePillClicked(e, dayNote)}
                       title={dayNote.note}>
            <BodySmall>{dayNote.note}</BodySmall>
          </DayNotePill>
        </React.Fragment>
      ))}
    </RecentNotesContainer>
  );
}

interface Props {
  whereaboutsOptionId: number;
  onNoteSelected: (e: Event, note: string) => void;
}
